import { Box, styled } from "@mui/material";
import {
  APP_BACKGROUND_COLOR,
  BUTTON_TEXT_COLOR,
  INITIAL_SETTINGS_BACKGROUND_COLOR,
  INITIAL_SETTINGS_BLACK_BACKGROUND_COLOR,
  THEME,
} from "../../theme";

export const styles = {
  stageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
  } as const,
  groupAddOutlinedIconContainer: {
    border: "2px solid #697177",
    borderRadius: "8px",
    width: "45px",
    height: "45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "3px",
  } as const,
  verticalBar: {
    border: "1px solid #202425",
    height: "35px",
    width: "1px",
    marginLeft: "25px",
  } as const,
  groupAddOutlinedIcon: {
    fontSize: "24px",
    margin: "3px",
    filter: THEME === "dark" ? "invert(0%)" : "invert(100%)",
  } as const,
  logoutMainContainer: {
    width: "100%",
    overflowY: "scroll",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  logoutContainer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 20px 0px 0px",
  } as const,
  logoutButton: {
    backgroundColor: APP_BACKGROUND_COLOR,
    border: `1px solid gray`,
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
  } as const
};

export const StagesLeftContainer = styled(Box)(({ theme }) => ({
  width: "600px",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: INITIAL_SETTINGS_BLACK_BACKGROUND_COLOR,
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const StagesRightSideContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: INITIAL_SETTINGS_BACKGROUND_COLOR,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "0 30px",
    overflow: "hidden",
  },
}));
